module.exports = __webpack_public_path__ + "static/media/yesterdayImageDesktop3.8dcf869b.png";